'use client'

export default function TypingIndicator() {
  return (
    <div className="flex justify-start animate-message-fade-in">
      <div className="bg-[#f0f0f0] rounded-2xl rounded-bl-md px-4 py-3 flex items-center gap-1">
        <span className="w-2 h-2 bg-[#888] rounded-full animate-typing-dot" style={{ animationDelay: '0s' }} />
        <span className="w-2 h-2 bg-[#888] rounded-full animate-typing-dot" style={{ animationDelay: '0.15s' }} />
        <span className="w-2 h-2 bg-[#888] rounded-full animate-typing-dot" style={{ animationDelay: '0.3s' }} />
      </div>
    </div>
  );
}
